/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CaptchaValidationRequest } from './captcha-validation-request';


export interface ForgotPasswordRequest { 
    login?: string | null;
    captcha?: CaptchaValidationRequest;
    isViaEmail?: boolean;
}

